export default "__VITE_ASSET__D2STTiX___"